// =============================================================================
// APPS PAGES LAYOUTS
// =============================================================================

export default {
    path: 'apps',
    component: () => import('../../views/admin/apps/index.vue'),
    children: [
      {
        path: '/',
        name: 'apps',
        component: () => import(/* webpackChunkName: "apps" */ '../../views/admin/apps/list/appsList.vue'),
        meta: {
          permission: 'app.show',
          pageTitle: 'باشگاه ها',
          pageTitleI18n: 'apps.list.title'
          // rule: 'editor'
        }
      },
      {
        path: 'trash',
        name: 'appsTrash',
        component: () => import(/* webpackChunkName: "appsTrash" */ '../../views/admin/apps/trash/appsTrash.vue'),
        meta: {
          permission: 'app.delete',
          pageTitle: 'سطل زباله باشگاه',
          pageTitleI18n: 'apps.trash.title'
          // rule: 'editor'
        }
      },
      {
        path: 'insert',
        name: 'insertApp',
        component: () => import(/* webpackChunkName: "insertApp" */ '../../views/admin/apps/insert/insertApp.vue'),
        meta: {
          permission: 'app.create',
          pageTitle: 'افزودن برنامه',
          pageTitleI18n: 'apps.insert.title'
          // rule: 'editor'
        }
      },
      {
        path: ':id',
        component: () => import('../../views/admin/apps/app/index.vue'),
        children: [
          {
            path: '/',
            component: () => import(/* webpackChunkName: "appProfile" */ '../../views/admin/apps/app/profile/appProfile.vue'),
            name: 'app',
            meta: {
              permission: 'app.show',
              pageTitle: 'باشگاه',
              pageTitleI18n: 'apps.profile.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'dashboard',
            component: () => import(/* webpackChunkName: "appDashboard" */ '../../views/admin/apps/app/dashboard/appDashboard.vue'),
            name: 'appDashboard',
            meta: {
              permission: 'app.show',
              pageTitle: 'باشگاه',
              pageTitleI18n: 'apps.dashboard.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'subscriptions',
            component: () => import('../../views/admin/apps/app/subscription/index.vue'),
            children: [
              {
                path: '',
                component: () => import(/* webpackChunkName: "appSubscriptionList" */ '../../views/admin/apps/app/subscription/list/subscriptionsList.vue'),
                name: 'appSubscriptionList',
                meta: {
                  permission: 'app_subscription.show',
                  pageTitle: 'باشگاه',
                  pageTitleI18n: 'subscriptions.list.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
              {
                path: 'insert',
                component: () => import(/* webpackChunkName: "insertAppSubscription" */ '../../views/admin/sales/subscription/insert/insertAppSubscription.vue'),
                name: 'insertAppSubscription',
                meta: {
                  permission: 'app_subscription.create',
                  pageTitle: 'باشگاه',
                  pageTitleI18n: 'subscriptions.insert.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
              {
                path: ':subscriptionId',
                component: () => import('../../views/admin/apps/app/subscription/index.vue'),
                children: [
                  {
                    path: '',
                    component: () => import(/* webpackChunkName: "appSubscription" */ '../../views/admin/sales/subscription/profile/appSubscription.vue'),
                    name: 'appSubscription',
                    meta: {
                      permission: 'app_subscription.show',
                      pageTitle: 'باشگاه',
                      pageTitleI18n: 'subscriptions.subscription.title',
                      layoutStatus: 'profile'
                      // rule: 'editor'
                    }
                  },
                  {
                    path: 'edit',
                    component: () => import(/* webpackChunkName: "editAppSubscription" */ '../../views/admin/sales/subscription/edit/editAppSubscription.vue'),
                    name: 'editAppSubscription',
                    meta: {
                      permission: 'app_subscription.update',
                      pageTitle: 'باشگاه',
                      pageTitleI18n: 'subscriptions.edit.title',
                      layoutStatus: 'profile'
                      // rule: 'editor'
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'credit',
            component: () => import(/* webpackChunkName: "setAppMaxDebt" */ '../../views/admin/apps/app/maxDebt/setAppMaxDebt.vue'),
            name: 'setAppMaxDebt',
            meta: {
              permission: 'app.set_max_debt',
              pageTitle: 'باشگاه',
              pageTitleI18n: 'apps.maxDebt.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "editApp" */ '../../views/admin/apps/edit/editApp.vue'),
            name: 'editApp',
            meta: {
              permission: 'app.update',
              pageTitle: 'ویرایش باشگاه',
              pageTitleI18n: 'apps.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'transactions',
            name: 'appTransactions',
            component: () => import(/* webpackChunkName: "appTransactions" */ '../../views/admin/apps/app/transactions/appTransactions.vue'),
            meta: {
              permission: 'app.show_transactions',
              pageTitle: 'گردش مالی برنامه',
              pageTitleI18n: 'apps.transactions.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'sales',
            name: 'appInvoicesList',
            component: () => import(/* webpackChunkName: "appInvoicesList" */ '../../views/admin/apps/app/sales/appInvoicesList.vue'),
            meta: {
              permission: 'app.show',
              pageTitle: 'فاکتورهای برنامه',
              pageTitleI18n: 'apps.invoices.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'refunds',
            name: 'appRefundInvoicesList',
            component: () => import(/* webpackChunkName: "appRefundInvoicesList" */ '../../views/admin/apps/app/saleRefunds/appSaleRefundInvoicesList.vue'),
            meta: {
              permission: 'app.show',
              pageTitle: 'فاکتورهای مرجوعی برنامه',
              pageTitleI18n: 'apps.refundInvoices.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'employees',
            name: 'appEmployeesList',
            component: () => import(/* webpackChunkName: "appEmployeesList" */ '../../views/admin/apps/app/employees/appEmployeesList.vue'),
            meta: {
              permission: 'app_employee.show',
              pageTitle: 'کارمندان برنامه',
              pageTitleI18n: 'apps.employees.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'payment-methods',
            component: () => import('../../views/admin/apps/app/paymentMethods/index.vue'),
            children: [
              {
                path: '',
                name: 'appPaymentMethodsList',
                component: () => import(/* webpackChunkName: "appPaymentMethods" */ '../../views/admin/apps/app/paymentMethods/list/appPaymentMethodsList.vue'),
                meta: {
                  permission: 'app_payment_method.show',
                  pageTitle: 'روش های پرداخت برنامه',
                  pageTitleI18n: 'apps.paymentMethods.list.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
              {
                path: 'insert',
                name: 'insertAppPaymentMethod',
                component: () => import(/* webpackChunkName: "insertAppPaymentMethod" */ '../../views/admin/apps/app/paymentMethods/insert/insertAppPaymentMethod.vue'),
                meta: {
                  permission: 'app_payment_method.create',
                  pageTitle: 'افزودن روش پرداخت برنامه',
                  pageTitleI18n: 'apps.paymentMethods.insert.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
              {
                path: ':paymentMethodId/edit',
                name: 'editAppPaymentMethod',
                component: () => import(/* webpackChunkName: "editAppPaymentMethod" */ '../../views/admin/apps/app/paymentMethods/edit/editAppPaymentMethod.vue'),
                meta: {
                  permission: 'app_payment_method.update',
                  pageTitle: 'ویرایش روش پرداخت برنامه',
                  pageTitleI18n: 'apps.paymentMethods.edit.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
            ]
          },
          {
            path: 'activities-log',
            name: 'appActivitiesLog',
            component: () => import(/* webpackChunkName: "appActivitiesLog" */ '../../views/admin/apps/app/activitiesLog/appActivitiesLog.vue'),
            meta: {
              permission: 'activity_logs.show',
              pageTitle: 'لاگ های باشگاه',
              pageTitleI18n: 'apps.logs.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'deploy',
            component: () => import(/* webpackChunkName: "appDeploy" */ '../../views/admin/apps/app/deploy/appDeploy.vue'),
            name: 'appDeploy',
            meta: {
              permission: 'app.deploy',
              pageTitle: 'دیپلوی برنامه',
              pageTitleI18n: 'apps.deploy.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'requests',
            component: () => import(/* webpackChunkName: "appRequests" */ '../../views/admin/apps/app/request/list/appRequestList.vue'),
            name: 'appRequests',
            meta: {
              // permission: 'app_request.show',
              pageTitle: 'درخواست های باشگاه',
              pageTitleI18n: 'apps.requests.list.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'receives',
            component: () => import(/* webpackChunkName: "appReceives" */ '../../views/admin/apps/app/receive/list/appReceivesList.vue'),
            name: 'appReceives',
            meta: {
              permission: 'receive.show',
              pageTitle: 'دریافت های باشگاه',
              pageTitleI18n: 'apps.receives.list.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'receives/:receiveId',
            component: () => import(/* webpackChunkName: "appReceive" */ '../../views/admin/apps/app/receive/document/appReceiveDocument.vue'),
            name: 'appReceive',
            meta: {
              permission: 'receive.show',
              pageTitle: 'سند دریافت باشگاه',
              pageTitleI18n: 'apps.receives.document.title'
              // rule: 'editor'
            }
          }
        ]
      }
    ]
}
